/// <reference path="../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Apps {
    export class Triggers {
        static InitEditor(ViewPropertyID, EmailAddressPropertyID, PhoneNumberPropertyID) {
            var $Editor_View = $(".sumit-field-value[data-propertyid=" + ViewPropertyID + "]");
            var $Editor_EmailAddress = $(".sumit-field-value[data-propertyid=" + EmailAddressPropertyID + "]");
            var $Editor_PhoneNumber = $(".sumit-field-value[data-propertyid=" + PhoneNumberPropertyID + "]");
            $Editor_EmailAddress.find(".schemaviewpropertydetails > div:not(:last)").css("display", "none");
            $Editor_PhoneNumber.find(".schemaviewpropertydetails > div:not(:last)").css("display", "none");

            $Editor_View.find(".schemapicker").on("change.triggers", function () {
                var SchemaID = $(this).val();
                var Schema = Teva.SelectBox.GetInstance($Editor_View.find(".schemapicker"));
                Teva.SelectBox.GetInstance($Editor_EmailAddress.find(".schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
                Teva.SelectBox.GetInstance($Editor_PhoneNumber.find(".schemapicker")).SetValue(Schema.SelectedValue, Schema.SelectedText);
            });
            
            $Editor_View.find(".viewpicker").on("change.triggers", function () {
                var SchemaID = $(this).val();
                var View = Teva.SelectBox.GetInstance($Editor_View.find(".viewpicker"));
                Teva.SelectBox.GetInstance($Editor_EmailAddress.find(".viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
                Teva.SelectBox.GetInstance($Editor_PhoneNumber.find(".viewpicker")).SetValue(View.SelectedValue, View.SelectedText);
            });

            if ($Editor_EmailAddress.find("input:hidden").last().val() == "" || $Editor_EmailAddress.find("input:hidden").last().val() == "0" || $Editor_PhoneNumber.find("input:hidden").last().val() == "" || $Editor_PhoneNumber.find("input:hidden").last().val() == "0") {
                $Editor_View.find(".schemapicker").trigger("change.triggers");
                $Editor_View.find(".viewpicker").trigger("change.triggers");
            }
        }
    }
}
